import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import ServicesLanding from "../views/ServicesLanding";
import Mutton from "../views/services/Mutton";
import Avocados from "../views/services/Avocados";
import ServiceSunflower from "../views/services/ServiceSunflower";
import ServiceSesame from "../views/services/ServiceSesame";
import ServiceBeans from "../views/services/ServiceBeans";
import ServiceDistribution from "../views/services/ServiceDistribution";

export default function Services() {
  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  async function init() {
    // run initializations here
  }

  function getView() {
    if (!appContext.navSubItem && !appContext.navExtraItem && !appContext.navMoreItem) {
      return <ServicesLanding />;
    }

    if (appContext.navSubItem === "mutton") {
      return <Mutton />;
    }

    if (appContext.navSubItem === "avocados") {
      return <Avocados />;
    }

    if (appContext.navSubItem === "haulage") {
      return <ServiceSunflower />;
    }

    if (appContext.navSubItem === "coal") {
      return <ServiceSesame />;
    }

    if (appContext.navSubItem === "flatdeck") {
      return <ServiceBeans />;
    }

    if (appContext.navSubItem === "tipping") {
      return <ServiceDistribution />;
    }

    return <ServicesLanding />;
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    const nextView = getView();
    if (nextView) {
      setView(nextView);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  return view;
}
